import { Text } from '@cmpsr/components';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import useAnalyticsCalls from '@/hooks/use-analytics';
import { useEffect } from 'react';

export default function DashboardHeaderIncomplete({ name }: { name: string | undefined }) {
  const { callPageView } = useAnalyticsCalls();

  useEffect(() => {
    callPageView({
      page_title: 'Risk Assessment Incomplete',
    });
  }, [callPageView]);
  const greeting = name ? `Hi ${name}, ` : '';
  const riskAssessmentWithUserText = 'please complete your ';
  const riskAssessmentText = (
    <Text as="span" textStyle="text-header-2xl-v" color="text-light">
      Risk Assessment{' '}
    </Text>
  );
  const riskAssessmentWithoutUserText = name ? '' : ' to see your personal risk';

  const nameLiteral = name ? (
    <Text variant="text-header-2XL" color="text-light" display={{ base: 'inline', lg: 'block' }}>
      {greeting}
      {riskAssessmentWithUserText}
      {riskAssessmentText}
      {riskAssessmentWithoutUserText}
    </Text>
  ) : (
    <Text variant="text-header-2XL" color="text-light" display={{ base: 'inline', lg: 'block' }}>
      Please complete your{' '}
      <Text as="span" textStyle="text-header-2xl-v" color="text-light">
        Risk Assessment{' '}
      </Text>
      to see your personal risk
    </Text>
  );

  return (
    <DashboardLayout
      containerProps={{ background: 'gradient.dark' }}
      contentProps={{
        as: 'header',
        p: { base: 'spacer-4', lg: 'spacer-6' },
        border: '1px solid',
        borderColor: 'medBlue',
        borderRadius: 'radii-3',
        alignItems: 'center',
      }}
    >
      {nameLiteral}
    </DashboardLayout>
  );
}
